// extracted by mini-css-extract-plugin
export default {"operationArea":"listOperationArea_operationArea__iDl8H"};